export default __webpack_public_path__ + "static/media/Picture2.7442d499.png";